import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { I } from './Icons'

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  margin-top: 28px;
  background: ${p => p.theme.colors.semantic.surface};
  border: 1px solid ${p => p.theme.colors.semantic.border};
  border-radius: 12px;
  box-shadow: ${p => p.theme.colors.semantic.shadowSm};
`

const Info = styled.div`
  flex: 1;
`

const InfoT = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 2px;
`

const InfoD = styled.div`
  font-size: 12px;
  color: ${p => p.theme.colors.semantic.textMuted};
`

const PillBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid ${p => p.theme.colors.semantic.border};
  background: ${p => p.theme.colors.semantic.surface};
  color: ${p => p.theme.colors.semantic.textPrimary};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: ${p => p.theme.colors.semantic.surfaceMuted};
  }
`

const PillBtnPrimary = styled(PillBtn)`
  background: ${p => p.theme.colors.semantic.accent};
  border-color: ${p => p.theme.colors.semantic.accent};
  color: #fff;
  &:hover {
    background: ${p => p.theme.colors.semantic.accentHover};
    border-color: ${p => p.theme.colors.semantic.accentHover};
  }
`

const WipAiExportFooter = ({ revNumber, caption, monthLabelText, onPreview, onExportStub }) => (
  <Footer>
    <Info>
      <InfoT>Export uses the currently selected revision</InfoT>
      <InfoD>
        Rev {revNumber} · {caption} · {monthLabelText}
      </InfoD>
    </Info>
    <PillBtn type="button" onClick={onPreview}>
      <I.eye /> Preview .docx
    </PillBtn>
    <PillBtnPrimary type="button" onClick={onExportStub}>
      <I.dl /> Export .docx
    </PillBtnPrimary>
  </Footer>
)

WipAiExportFooter.propTypes = {
  revNumber: PropTypes.number.isRequired,
  caption: PropTypes.string.isRequired,
  monthLabelText: PropTypes.string.isRequired,
  onPreview: PropTypes.func.isRequired,
  onExportStub: PropTypes.func.isRequired,
}

export default WipAiExportFooter
